import { Outlet } from "react-router-dom";
import { LocationProvider } from "@/contexts/LocationContext";

export default function BookingLayout() {
  return (
    <LocationProvider>
      <div className="min-h-screen bg-gray-50">
        <main>
          <Outlet />
        </main>
      </div>
    </LocationProvider>
  );
} 